import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {  getLogoList } from "./ThunkAction";
import { iLogoResponse, iLogoState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iLogoState = {
  isLoading: false,
  logoList: [],
  errorMessage: null,
};

export const LogoSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetLogoState: () => {
      return initialState;
    },
    // Patches a logo entry in place right after a save, so checklist-style UI
    // (onboarding setup steps) can advance immediately instead of waiting on
    // a follow-up getLogoList() GET that can race with the backend write and
    // read back stale data.
    patchLogoEntry: (state, action: PayloadAction<Partial<iLogoResponse> & { id?: string }>) => {
      if (!state.logoList || state.logoList.length === 0) return;
      const index = action.payload.id
        ? state.logoList.findIndex((entry) => entry.id === action.payload.id)
        : 0;
      if (index === -1) return;
      state.logoList[index] = { ...state.logoList[index], ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLogoList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogoList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.logoList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getLogoList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Logo data";
        state.isLoading = false;
      });
  },
});

export const { resetLogoState, patchLogoEntry } = LogoSlice.actions;
export default LogoSlice.reducer;
